import apiEndPoints from "@/consts/apiEndPoints"
import api from "@/services/api"

/**
 *  @typedef {object} PalletBatch
 *  @property {unknown[]} id
 *  @property {number} id_bordero
 *  @property {number} cod_etiqueta
 *  @property {string} brd_data
 *  @property {string} cod_produto
 *  @property {number} etiq_qtde_cx
 *  @property {string} etiq_qtde
 *  @property {unknown[]} items
 *
 */

/**
 *
 * @param {{ productId: string }} props
 *
 * @returns {Promise<PalletBatch[]>}
 */
export async function getPalletBatches({ productId }) {
  const response = await api.get(apiEndPoints.miscellaneous.palletBatches, {
    params: {
      product_id: productId,
    },
  })

  return response.data
}

/**
 *
 * @param {{ orderItemId: string }} props
 *
 * @returns {Promise<PalletBatch>}
 */
export async function getPalletBatchByOrderItem({ orderItemId }) {
  const orderId = orderItemId.split(",").slice(0, 2)

  const URL = apiEndPoints.orders
    .orderItems(orderId, orderItemId)
    .concat("/pallet_batch")
  const response = await api.get(URL)

  return response.data
}
